import { useEffect } from 'react';

import { useResponsive } from '@depop/web-ui-kit/useResponsive';
import { usePathname } from 'next/navigation';

import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useProductsSearchBar() {
  const pathname = usePathname();
  const { isMaxMedium: isMobile } = useResponsive();

  const [{ web_7019_visible_search_bar_mweb }, bucketStickySearchbar] =
    useExperiments(['web_7019_visible_search_bar_mweb'], {
      deferred: true,
    });

  const isProductPage = pathname.startsWith('/products');

  useEffect(() => {
    if (isProductPage && isMobile) {
      bucketStickySearchbar();
    }
  }, [isProductPage, isMobile]);

  return {
    isVisible: isProductPage && isMobile,
    isSticky:
      web_7019_visible_search_bar_mweb === VARIANT_IDENTIFIER && isProductPage,
  };
}
